import { render, staticRenderFns } from "./ChoosePositionGlobe.vue?vue&type=template&id=1284f72e&scoped=true&"
import script from "./ChoosePositionGlobe.vue?vue&type=script&lang=js&"
export * from "./ChoosePositionGlobe.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePositionGlobe.vue?vue&type=style&index=0&id=1284f72e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284f72e",
  null
  
)

export default component.exports